module.exports = __webpack_public_path__ + "static/media/1POLICY12.f06492c8.jpg";